export const gopt_token = 'gopt_token';

export const Authorization = "Authorization";